<template>
  <el-container style="width:100%;">
    <el-main v-loading="loading">
      <el-card class="box-card" v-if="!this.shopInfo.my_pay_mid || !this.shopInfo.my_pay_api_key">
        <el-row type="flex">
          <el-col class="iepay-container">
            <img src="https://img.nzmai.com.cn/iepay_logo.png" class="iepay-logo" />
            <h4>IE PAY Payment</h4>
            <p class="iepay-intro">IE PAY is a multi-channel and multi-currency payments solution with an in-built digital marketing platform that supports businesses of all sizes with low costs. Currently available in New Zealand, IE PAY is an aggregated payment processing solution that allows merchants to accept <b>Alipay, WeChat Pay, UnionPay and POLi</b> at attractive rates.</p>
            <div class="iepay-section-bottom">
              <div class="iepay-onboard-section">
                <a href="https://a.mypaynz.com/account/step0?reference=ieshop" target="_blank">
                  <el-button class="apply-iepay-btn">
                    Apply for IE PAY Payment
                  </el-button>
                  <span class="apply-hint"> (Do not have IE PAY account)</span>
                </a>
                <div style="margin-top: 10px;">
                  <el-button type="success" @click="goToShopDetail">
                    Complete Payment Information
                  </el-button>
                  <span class="apply-hint"> (Have IE PAY account)</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card">
        <el-row type="flex">
          <el-col class="paypal-container">
            <img :src="require('@/assets/img/paypal_logo.svg')" class="paypal-logo" />
            <h4>Express Checkout</h4>
            <p>By connecting your paypal account, you can accept credit card payment and other paypal payments.</p>
            <p>Selling is <b><el-link type="primary" href="https://www.paypal.com/nz/webapps/mpp/paypal-fees">3.4% + $0.45 NZD</el-link></b> per payment within New Zealand.</p>
            <p><b>PayPal sales are settled in real time. </b>Click <el-link type="primary" href="https://www.paypal.com/nz/webapps/mpp/merchant">here</el-link> to check your PayPal balance.</p>
            <p>Sellers pay <b>$0.45 NZD</b> for each refund.</p>
            <div class="paypal-section-bottom">
              <div class="paypal-onboard-section">
                <a :href="paypal_action_link">
                  <el-button v-if="!is_paypal_onboard">
                    Set PayPal Express Checkout
                  </el-button>
                  <el-button v-else>
                    <i class="el-icon-circle-check" /> Manage PayPal Express Checkout
                  </el-button>
                </a>
                <div class="paypal-onboard-alerts">
                  <el-alert v-if="is_paypal_onboard"
                    title="Only PayPal business account can accept Credit Card Payments."
                    type="info"
                    show-icon>
                    <b>If your PayPal account is not business account, </b>
                    <a href="https://www.paypal.com/mt/smarthelp/article/how-do-i-upgrade-from-a-premier-to-a-business-account-faq1317">Please upgrade to business account</a><br />
                  </el-alert>
                  <el-alert v-if="seller_paypal_merchant_id && !is_primary_email_confirmed"
                    title="Please activate your PayPal account"
                    type="error"
                    show-icon>
                    <a href="https://www.paypal.com/nz/smarthelp/article/i-did-not-receive-my-email-address-confirmation-faq831">Activate your business account</a>
                  </el-alert>
                  <el-alert v-if="seller_paypal_merchant_id && !is_permission_granted"
                    title="Please grant permissions to customer service"
                    type="error"
                    description="Please set paypal express checkout again"
                    show-icon>
                  </el-alert>
                  <el-alert v-if="seller_paypal_merchant_id && !is_payments_receivable"
                    title="You PayPal account is not able to accept payments"
                    type="error"
                    description="Please call PayPal "
                    show-icon>
                  </el-alert>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card" v-if="this.shopInfo.my_pay_mid !== null && this.shopInfo.my_pay_api_key !== null">
        <el-row type="flex" align="middle" class="payment-container">
          <el-col :span="2">
            <img src="https://img.nzmai.com.cn/wechat_pay.png" alt class="payment-icon" />
          </el-col>
          <el-col :span="20" style="padding-top: 10px;">{{generateCustomizeString('wechatPay')}}</el-col>
          <el-col :span="2">
            <el-switch v-model="is_wechat" @change="updatePaymentMethods"></el-switch>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" class="payment-container">
          <el-col :span="2">
            <img src="https://img.nzmai.com.cn/alipay.png" alt class="payment-icon" />
          </el-col>
          <el-col :span="20" style="padding-top: 10px;">{{generateCustomizeString('alipay')}}</el-col>
          <el-col :span="2">
            <el-switch v-model="is_alipay" @change="updatePaymentMethods"></el-switch>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" class="payment-container">
          <el-col :span="2">
            <img src="https://img.nzmai.com.cn/unionpay_logo_new.png" alt class="payment-icon" />
          </el-col>
          <el-col :span="20" style="padding-top: 10px;">UnionPay</el-col>
          <el-col :span="2">
            <el-switch v-model="is_unionsecure" @change="updatePaymentMethods"></el-switch>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" class="payment-container">
          <el-col :span="2">
            <img src="https://img.nzmai.com.cn/polipay.png" alt class="payment-icon" />
          </el-col>
          <el-col :span="20" style="padding-top: 10px;">{{generateCustomizeString('polipay')}}</el-col>
          <el-col :span="2">
            <el-switch v-model="is_poli" @change="updatePaymentMethods"></el-switch>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" align="middle" class="payment-container">
          <el-col :span="2">
            <img src="https://img.nzmai.com.cn/unionpay_logo.png" alt class="payment-icon" />
          </el-col>
          <el-col :span="20" style="padding-top: 10px;">{{generateCustomizeString('unionpay')}}</el-col>
          <el-col :span="2">
            <el-switch v-model="is_unionpay" @change="updatePaymentMethods"></el-switch>
          </el-col>
        </el-row> -->
        <el-row v-if="is_paypal_onboard" type="flex" align="middle" class="payment-container">
          <el-col :span="2">
            <img src="https://www.paypalobjects.com/webstatic/icon/pp258.png" alt class="payment-icon" />
          </el-col>
          <el-col :span="20" style="padding-top: 10px;">PayPal</el-col>
          <el-col :span="2">
            <el-switch v-model="is_paypal" @change="updatePaymentMethods"></el-switch>
          </el-col>
        </el-row>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'PaymentMethodManagement',
  data() {
    return {
      loading: true,
      is_wechat: true,
      is_alipay: true,
      is_poli: true,
      is_transfer: true,
      is_unionpay: false,
      is_unionsecure: false,
      is_paypal: false,
      paypal_action_link: '',
      is_paypal_onboard: false,
      is_primary_email_confirmed: false,
      is_permission_granted: false,
      is_payments_receivable: false,
      seller_paypal_merchant_id: null,
      is_iepay_onboard: false,
      shopInfo: {}
    }
  },
  created: function() {
    this.fetchPaymentMethod()
    this.initPaypalOnboardingState()
    this.fetchShop()
  },
  methods: {
    generateCustomizeString,
    updatePaymentMethods() {
      request({
        url: '/payment',
        method: 'put',
        params: {
          is_wechat: this.is_wechat,
          is_alipay: this.is_alipay,
          is_poli: this.is_poli,
          is_transfer: this.is_transfer,
          is_unionpay: this.is_unionpay,
          is_paypal: this.is_paypal,
          is_unionsecure: this.is_unionsecure
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .finally(() => {})
    },
    fetchPaymentMethod() {
      request({
        url: '/payment',
        method: 'get'
      })
        .then(res => {
          this.is_wechat = res.data.is_wechat === 1
          this.is_alipay = res.data.is_alipay === 1
          this.is_poli = res.data.is_poli === 1
          this.is_credit_card = res.data.is_credit_card === 1
          this.is_transfer = res.data.is_transfer === 1
          this.is_unionpay = res.data.is_unionpay === 1
          this.is_paypal = res.data.is_paypal === 1
          this.is_unionsecure = res.data.is_unionsecure === 1
        })
        .catch(error => {
          console.log(error)
        })
    },
    initPaypalOnboardingState() {
      const domain = process.env.VUE_APP_DOMAIN_URL
      request({
        url: domain + 'shop/paypal/init-onboarding-state',
        method: 'post'
      })
        .then(res => {
          this.loading = false
          if (res.status !== 0) {
            this.$message.warning(this.generateCustomizeString('initializeFailed'))
            return
          }
          this.is_paypal_onboard = res.data.is_onboard
          this.is_primary_email_confirmed = res.data.primary_email_confirmed
          this.is_permission_granted = res.data.permission_granted
          this.is_payments_receivable = res.data.payments_receivable
          this.seller_paypal_merchant_id = res.data.merchant_id
          this.paypal_action_link = res.data.action_link
        })
        .catch(error => {
          this.loading = false
          console.log(error)
          this.$message.error(this.generateCustomizeString('initializeFailed'))
        })
    },
    fetchShop() {
      request({
        url: 'basic',
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            this.shopInfo = res.data
            // console.log(this.shopInfo)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    goToShopDetail() {
      this.$router.push({
        name: 'ShopDetail',
        params: { activeName: '3' }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.payment-icon {
  width: 40px;
}
.box-card {
  margin-bottom: 10px;
}
.payment-container {
  min-height: 55px;
  margin-top: 3px;
  margin-bottom: 3px;
  background-color: #f7f7f7;
  padding: 3px;
}
.btn-update {
  margin-top: 20px;
}
.paypal-container {
  .paypal-logo {
    width: 120px;
  }
  p {
    color: #000;
    font-size: .8rem;
  }
  .el-link {
    font-size: .8rem;
  }

  .paypal-section-bottom {
    a {
      font-size: .8rem;
      color: #425077;
    }
    .paypal-onboard-section {
      margin-top: 10px;
      .el-tag {
        font-size: .8rem;
      }
      .el-button {
        background-color: #425077;
        color: #fff;
      }

      .paypal-onboard-alerts {
        margin-top: 20px;
        .el-alert {
          margin-top: 3px;
        }
      }
    }
  }
}
.iepay-container {
  .iepay-logo {
    width: 120px;
  }
  .iepay-intro {
    line-height: 18px;
  }
  p {
    color: #000;
    font-size: .8rem;
  }
  .el-link {
    font-size: .8rem;
  }

  .iepay-section-bottom {
    a {
      font-size: .8rem;
      color: #425077;
    }
    .iepay-onboard-section {
      margin-top: 10px;
      .el-tag {
        font-size: .8rem;
      }
      .apply-iepay-btn {
        background-color: #425077;
        color: #fff;
      }
      .iepay-onboard-alerts {
        margin-top: 20px;
        .el-alert {
          margin-top: 3px;
        }
      }
      .apply-hint {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
.paypal-setup-warning {
    padding: 4px 15px;
    background-color: #fff6f7;
    border-radius: 4px;
    border-left: 5px solid #fe6c6f;
    margin: 20px 0;
    font-size: .8rem;
}
</style>
